import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword, signInWithPopup, GoogleAuthProvider, sendPasswordResetEmail } from 'firebase/auth';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { auth, db } from '../config/firebase';
import googleLogo from '../assets/google.svg';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();


  const handleEmailLogin = async (e) => {
    e.preventDefault();
    try {
      setError('');
      setLoading(true);
      
      // Sign in user
      const result = await signInWithEmailAndPassword(auth, email, password);
      
      // Check if this is their first login
      const userDoc = doc(db, 'users', result.user.uid);
      const userSnap = await getDoc(userDoc);
      
      if (!userSnap.exists()) {
        // First time user
        await setDoc(userDoc, {
          email: result.user.email,
          firstLogin: true,
          createdAt: new Date()
        });
        navigate('/change-password');
      } else {
        // Existing user - check firstLogin status
        const userData = userSnap.data();
        if (userData.firstLogin === true) {
          navigate('/change-password');
        } else {
          navigate('/ftso-submissions');
        }
      }
    } catch (error) {
      setError('Failed to sign in: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleLogin = async () => {
    try {
      setError('');
      setLoading(true);
      const provider = new GoogleAuthProvider();
      await signInWithPopup(auth, provider);
      navigate('/ftso-submissions');
    } catch (error) {
      setError('Failed to sign in with Google: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleResetPassword = async () => {
    if (!email) {
      setError('Please enter your email address');
      return;
    }

    try {
      setError('');
      setMessage('');
      setLoading(true);
      await sendPasswordResetEmail(auth, email);
      setMessage('Check your email for password reset instructions');
    } catch (error) {
      setError('Failed to reset password: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-form">
        <h2>Login</h2>
        {error && <div className="error-message">{error}</div>}
        {message && <div className="success-message">{message}</div>}
        <form onSubmit={handleEmailLogin}>
          <div className="form-group">
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className="form-group">
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button 
              type="button" 
              onClick={handleResetPassword}
              className="forgot-password-link"
            >
              Forgot Password?
            </button>
          </div>
          <button type="submit" disabled={loading}>
            {loading ? 'Logging in...' : 'Login with Email'}
          </button>
        </form>

        <button 
          onClick={handleGoogleLogin} 
          disabled={loading}
          className="google-button"
        >
          <span className="google-button-content">
            <img src={googleLogo} alt="Google" className="google-icon" />
            <span>Login with Google</span>
          </span>
        </button>
      </div>
    </div>
  );
}

export default Login;